import log from 'salvo-lite/log'
import Helpers from '../helpers/Helpers'

class Product {
    constructor (theme, elem) {
        this.theme = theme
        this._name = this.constructor.name
        this._elem = elem
        this.options = Object.assign({
            enableHistoryState: true
        }, JSON.parse(this._elem.dataset.product || '{}'))
        this.product = this._elem.querySelector('[data-product-json]') ? JSON.parse(this._elem.querySelector('[data-product-json]').innerHTML) : null
        this.singleOptionSelectors = this._elem.querySelectorAll('[data-single-option-selector]')
        this.currentVariant = this.getVariantFromOptions()
        this.originalSelectors = this._elem.querySelectorAll('[data-product-select]')
        this.priceWrappers = this._elem.querySelectorAll('[data-price-wrapper]')
        this.productPrices = this._elem.querySelectorAll('[data-product-price]')
        this.productComparePrices = this._elem.querySelectorAll('[data-compare-price]')
        this.quantitySelects = this._elem.querySelectorAll('[data-quantity]')
        this.productImages = this._elem.querySelectorAll('[data-image-for]')
        this.combinedTitles = this._elem.querySelectorAll('[data-combined-title]')
        this.addToCarts = this._elem.querySelectorAll('[data-add-to-cart]')
        this.addToCartTexts = this._elem.querySelectorAll('[data-add-to-cart-text]')
        this.productImages = this._elem.querySelectorAll('[data-product-image]')

        // QUANTITY
        this.quantityInput = this._elem.querySelector('[data-product-quantity]')
        this.quantityLevels = null

        // TRADE PRICE
        this.tradePriceElem = this._elem.querySelector('[data-trade-total-price]')
    }

    cleanUpQuantityLevels () {
        this.quantityLevels = this._elem.querySelectorAll('[data-quantity-levels]')
        if (this.quantityLevels.length > 1) {
            for (let [i, level] of this.quantityLevels.entries()) {
                if (i === 0) continue
                level.parentNode.removeChild(level)
            }
        }
    }

    doQuantityLevels () {
        this.cleanUpQuantityLevels()
        this.quantityLevels = this._elem.querySelectorAll('[data-quantity-levels] [data-quantity-level]')
        let lastLevelPrice = null
        for (let level of this.quantityLevels) {
            let quantity = parseInt(level.querySelector('[data-quantity]').textContent)
            let price = level.querySelector('[data-price]').textContent

            if (quantity === 1) {
                level.classList.add('hide')
            }

            if (lastLevelPrice === price) {
                level.classList.add('hide')
            }

            if (parseInt(this.quantityInput.value) >= quantity) {
                level.classList.add('active')
            } else {
                level.classList.remove('active')
            }

            lastLevelPrice = price
        }
        if (this._elem.querySelector('[data-quantity-levels]')) {
            this._elem.querySelector('[data-quantity-levels]').classList.add('shown')
        }
    }

    doTradePrice () {
        this.cleanUpQuantityLevels()
        this.quantityLevels = this._elem.querySelectorAll('[data-quantity-levels] [data-quantity-level]')
        let activeLevels = Array.from(this.quantityLevels).filter(level => level.classList.contains('active'))
        if (activeLevels.length) {
            let lastActive = activeLevels[activeLevels.length - 1]
            let priceForActive = Number(lastActive.querySelector('[data-price]').textContent.replace(/[^0-9.-]+/g, '')) * 100.00
            let currentQuantity = parseInt(this.quantityInput.value)
            this.tradePriceElem.textContent = Helpers.formatMoney(priceForActive * currentQuantity)
            this.tradePriceElem.classList.remove('hide')
        }
    }

    triggerEvent (elem = this._elem, name = 'event', data = {}) {
        elem.dispatchEvent(new CustomEvent(name, { detail: data }))
    }

    onInit () {
        log.debug(this._name, 'Initiating', this)

        if (this.product === null) {
            return false
        }

        for (let quantitySelect of this.quantitySelects) {
            quantitySelect.addEventListener('change', (e) => {
                for (let otherSelector of this.quantitySelects) {
                    if (otherSelector !== quantitySelect) {
                        otherSelector.value = quantitySelect.value
                        otherSelector.dispatchEvent(new CustomEvent('update-choices', { detail: quantitySelect.value }))
                    }
                }
            })
        }

        for (let optionSelector of this.singleOptionSelectors) {
            optionSelector.addEventListener('change', (e) => {
                // for (let otherSelector of this.singleOptionSelectors) {
                //     if (otherSelector.dataset.index === optionSelector.dataset.index && otherSelector !== optionSelector) {
                //         otherSelector.value = optionSelector.value
                //         otherSelector.dispatchEvent(new CustomEvent('update-choices', { detail: optionSelector.value }))
                //     }
                // }
                this.onSelectChange()
            })
        }

        this.onSelectChange()

        let i = 0
        let interval = setInterval(() => {
            console.log('running')
            if (this._elem.querySelector('[data-quantity-levels]')) {
                this.doQuantityLevels()
                this.doTradePrice()
                clearInterval(interval)
            }
            if (i++ > 100) {
                clearInterval(interval)
            }
        }, 100)

        this.quantityInput.addEventListener('input', e => {
            this.doQuantityLevels()
            this.doTradePrice()
        })

        log.debug(this._name, 'Initated', this)
    }

    _linkedOptions (variant) {
        for (let optionSelector of this.singleOptionSelectors) {
            optionSelector.classList.remove('disabled')

            for (let prodVariant of this.product.variants) {
                if (prodVariant.option1 === variant.option1 && optionSelector.value === prodVariant.option2 && !prodVariant.available) {
                    optionSelector.classList.add('disabled')
                }
            }
        }
    }

    /**
   * Event handler for when a variant input changes.
   */
    onSelectChange () {
        let variant = this.getVariantFromOptions()

        this.updateAddToCartState(variant)
        if (!variant) {
            return
        }

        this.updateMasterSelect(variant)
        this.updateProductPrices(variant)
        this.switchToVariantImage(variant)
        this.updateVariantTitles(variant)
        this.updateImages(variant)
        this._linkedOptions(variant)
        this.currentVariant = variant
        this.triggerEvent(this.elem, 'variantChange', variant)
        document.dispatchEvent(new Event('add-remove-tax--refresh'))

        if (this.options.enableHistoryState) {
            this.updateHistoryState(variant)
        }
    }

    updateImages (variant) {
        let hasShownImage = false
        for (let image of this.productImages) {
            image.classList.add('hide')
            if (image.dataset.productImage.split(',').includes(`${variant.id}`)) {
                image.classList.remove('hide')
                hasShownImage = true
            }
        }
        if (!hasShownImage && this.productImages.length) {
            this.productImages[0].classList.remove('hide')
        }
    }

    updateVariantTitles (variant) {
        for (let elem of this.combinedTitles) {
            if (elem.nodeName === 'INPUT') {
                elem.value = `${this.product.title} - ${variant.title}`
            } else {
                elem.textContent = `${this.product.title} - ${variant.title}`
            }
        }
    }

    /**
   * Update history state for product deeplinking
   *
   * @param {object} variant - Currently selected variant
   */
    updateHistoryState (variant) {
        if (!history.replaceState || !variant) {
            return
        }

        let newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id
        window.history.replaceState({ path: newurl }, '', newurl)
    }

    /**
   * Updates the DOM state of the add to cart button
   *
   * @param {boolean} enabled - Decides whether cart is enabled or disabled
   * @param {string} text - Updates the text notification content of the cart
   */
    updateAddToCartState (variant) {
        if (variant) {
            for (let priceWrapper of this.priceWrappers) {
                priceWrapper.classList.remove('hide')
            }
        } else {
            for (let addToCart of this.addToCarts) {
                addToCart.setAttribute('disabled', 'disabled')
            }
            // for (let addToCartText of this.addToCartTexts) {
            //     addToCartText.innerHTML = 'Make a selection'
            // }
            // for (let priceWrapper of this.priceWrappers) {
            //     priceWrapper.classList.add('hide')
            // }
            return
        }

        if (variant.available) {
            for (let addToCart of this.addToCarts) {
                addToCart.removeAttribute('disabled')
            }
            for (let addToCartText of this.addToCartTexts) {
                addToCartText.innerHTML = 'Add to basket'
            }
        } else {
            for (let addToCart of this.addToCarts) {
                addToCart.setAttribute('disabled', 'disabled')
            }
            for (let addToCartText of this.addToCartTexts) {
                addToCartText.innerHTML = 'Sold Out'
            }
        }
    }

    switchToVariantImage (variant) {
        for (let productImage of this.productImages) {
            if (productImage.dataset.imageFor) {
                let idArray = productImage.dataset.imageFor.split(',')
                if (idArray.includes(variant.id.toString())) {
                    let mainSlider = this.theme.getComponentsById('mainProductSlider')
                    mainSlider.goToSlide(productImage.dataset.slickIndex)
                }
            }
        }
    }

    /**
   * Updates the DOM with specified prices
   *
   * @param {string} productPrice - The current price of the product
   * @param {string} comparePrice - The original price of the product
   */
    updateProductPrices (variant) {
        for (let productPrice of this.productPrices) {
            if (variant.compare_at_price > variant.price) {
                productPrice.innerHTML = `${this.formatMoney(variant.price)}`
                productPrice.setAttribute('data-money', variant.price)
            } else {
                productPrice.innerHTML = this.formatMoney(variant.price)
                productPrice.setAttribute('data-money', variant.price)
            }
        }

        for (let productComparePrice of this.productComparePrices) {
            if (variant.compare_at_price > variant.price) {
                productComparePrice.innerHTML = `${this.formatMoney(variant.compare_at_price)}`
                productComparePrice.setAttribute('data-money', variant.compare_at_price)
            } else {
                productComparePrice.innerHTML = ''
                productComparePrice.classList.add('hide')
            }
        }

        // if (!variant.available) {
        //     for (let productPrice of this.productPrices) {
        //         productPrice.innerHTML = 'Unavailable'
        //     }
        //     for (let productComparePrice of this.productComparePrices) {
        //         productComparePrice.classList.add('hide')
        //     }
        // }
    }

    /**
   * Update hidden master select of variant change
   *
   * @param {object} variant - Currently selected variant
   */
    updateMasterSelect (variant) {
        for (let originalSelector of this.originalSelectors) {
            originalSelector.value = variant.id
        }
    }

    getCurrentOptions () {
        let currentOptions = []
        for (let optionSelector of this.singleOptionSelectors) {
            let type = optionSelector.getAttribute('type')
            let currentOption = {}
            let alreadyDone = false
            for (let option of currentOptions) {
                if (option.index === optionSelector.dataset.index) {
                    alreadyDone = true
                }
            }
            if (alreadyDone) continue
            if (type === 'radio' || type === 'checkbox') {
                if (optionSelector.checked) {
                    currentOption.value = optionSelector.value
                    currentOption.index = optionSelector.dataset.index
                    currentOptions.push(currentOption)
                } else {
                    currentOptions.push(false)
                }
            } else {
                currentOption.value = optionSelector.value
                currentOption.index = optionSelector.dataset.index
                currentOptions.push(currentOption)
            }
        }

        // remove any unchecked input values if using radio buttons or checkboxes
        currentOptions = this.compact(currentOptions)
        return currentOptions
    }

    /**
   * Find variant based on selected values.
   *
   * @param  {array} selectedValues - Values of variant inputs
   * @return {object || undefined} found - Variant object from product.variants
   */
    getVariantFromOptions () {
        let selectedValues = this.getCurrentOptions()
        let variants = this.product.variants
        let found = false

        for (let variant of variants) {
            var satisfied = true

            for (let option of selectedValues) {
                if (satisfied) {
                    satisfied = (option.value === variant[option.index])
                }
            }

            if (satisfied) {
                found = variant
            }
        }

        return found || null
    }

    compact (array) {
        var index = -1
        var length = array == null ? 0 : array.length
        var resIndex = 0
        var result = []

        while (++index < length) {
            var value = array[index]
            if (value) {
                result[resIndex++] = value
            }
        }
        return result
    }

    formatMoney (amount) {
        return Helpers.formatMoney(amount)
    }
}

export default Product



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Product.js